import { Map } from '@opengov/compose-app/immutable';
import { IStory } from '@opengov/stories-shared/types';
import { createContext, useContext } from 'react';

import { ESelectAllStatus } from '../../../types';

export const StoryListContext = createContext({
  selectedStories: Map<string, IStory>([]),
  highlightedStoriesIds: [],
  selectAllStatus: ESelectAllStatus.None,
  setSelectedStories: (_stories: Map<string, IStory>) => { },
  setHighlightedStoriesIds: (_storiesIds: string[]) => { },
  setSelectAllStatus: (_selectAllStatus: ESelectAllStatus) => { }
});

export const useStoryListContext = () => useContext(StoryListContext);
